(function () {
    'use strict';

    angular.module("imApp").factory("interBranchInvoicingMiService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 800,
                    parameters: parms || {}
                });
            },
            createInvoice: function (edit) {
                return $ihttp.post({
                    method: 802,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
